import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Check, X, ArrowRight, Sparkles } from 'lucide-react';
import { FloatingDoodles } from '../components/Doodles';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ScanPage() {
  const { taskId } = useParams();
  const [params] = useSearchParams();
  const token = params.get('t');
  const [state, setState] = useState('loading'); // loading | ok | already | error
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!token || !taskId) {
      setState('error');
      setErr('Saknar QR-data');
      return;
    }
    (async () => {
      try {
        const { data } = await axios.post(`${API}/cleaning/scan/${taskId}`, { token });
        setData(data);
        setState(data.already_done ? 'already' : 'ok');
      } catch (e) {
        setErr(e.response?.data?.detail || 'Något gick fel');
        setState('error');
      }
    })();
  }, [taskId, token]);

  return (
    <div className="min-h-screen bg-transparent flex items-center justify-center p-4 relative">
      <FloatingDoodles />
      <div className="w-full max-w-sm relative z-10">
        <div className="neo-card p-8 text-center bg-white" data-testid="scan-page">
          {state === 'loading' && (
            <>
              <div className="text-5xl mb-3 animate-pulse-soft">🐾</div>
              <p className="font-bold font-['Fredoka']">Registrerar…</p>
            </>
          )}
          {state === 'ok' && (
            <>
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#B9FBC0] border-3 border-black shadow-[4px_4px_0_#000] mb-4">
                <Check className="w-10 h-10" />
              </div>
              <h1 className="text-2xl font-bold font-['Fredoka'] mb-1">Bra jobbat! 🎉</h1>
              <p className="text-gray-600 mb-3">{data?.task_title}</p>
              <div className="inline-block bg-[#FDF0D5] px-4 py-2 rounded-full border-2 border-black font-bold flex items-center gap-1 mx-auto">
                <Sparkles className="w-4 h-4" /> +{data?.points_earned} poäng
              </div>
              <p className="text-xs opacity-60 mt-4">Kan stängas — ditt husdjur är stolt över dig! 🐾</p>
            </>
          )}
          {state === 'already' && (
            <>
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#FDF0D5] border-3 border-black shadow-[4px_4px_0_#000] mb-4">
                <Check className="w-10 h-10" />
              </div>
              <h1 className="text-xl font-bold font-['Fredoka'] mb-1">Redan klart! ✨</h1>
              <p className="text-gray-600 text-sm">{data?.task_title} har du redan gjort under denna period. Bra att du är noggrann!</p>
            </>
          )}
          {state === 'error' && (
            <>
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#FFC8DD] border-3 border-black shadow-[4px_4px_0_#000] mb-4">
                <X className="w-10 h-10" />
              </div>
              <h1 className="text-xl font-bold font-['Fredoka'] mb-1">Hoppsan</h1>
              <p className="text-gray-600 text-sm mb-3">{err}</p>
            </>
          )}
          <Link to="/dashboard" className="neo-btn mt-4 inline-flex items-center gap-1 px-4 py-2 bg-[#A2D2FF] text-sm font-bold" data-testid="scan-open-dashboard">
            Öppna appen <ArrowRight className="w-3 h-3" />
          </Link>
        </div>
      </div>
    </div>
  );
}
